/**
 * Sticky Add To Cart
 * Shows/hides the sticky bar based on the main ATC button's visibility.
 * Syncs variant state with the main product section via custom events.
 */
(function () {
  var SCROLL_THRESHOLD = 600;

  function StickyATC(sectionEl) {
    this.section = sectionEl;
    this.observer = null;
    this.footerObserver = null;
    this.scrollHandler = null;
    this.ticking = false;
    this.isVisible = false;
    this.footerVisible = false;
    this.init();
  }

  StickyATC.prototype.init = function () {
    var self = this;

    /* Show/Hide based on main ATC visibility
       ====================================================================== */

    var mainAtcButton =
      document.querySelector('.oddit-section-main-product__atc-button') ||
      document.querySelector('[data-add-to-cart]') ||
      document.querySelector('form[action*="/cart/add"] button[type="submit"]');

    if (mainAtcButton) {
      this.observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              self.hide();
            } else {
              // Only show when scrolled below the button, not above it
              var rect = mainAtcButton.getBoundingClientRect();
              if (rect.bottom < 0) {
                self.show();
              } else {
                self.hide();
              }
            }
          });
        },
        { root: null, threshold: 0 },
      );
      this.observer.observe(mainAtcButton);
    } else {
      this.scrollHandler = function () {
        if (!self.ticking) {
          window.requestAnimationFrame(function () {
            if (window.scrollY > SCROLL_THRESHOLD) {
              self.show();
            } else {
              self.hide();
            }
            self.ticking = false;
          });
          self.ticking = true;
        }
      };

      window.addEventListener('scroll', this.scrollHandler, { passive: true });
      this.scrollHandler();
    }

    /* Sync with main product variant changes
       ====================================================================== */

    this.variantChangeHandler = function (e) {
      var detail = e.detail;
      if (!detail) return;

      var variant = detail.variant;
      var options = detail.selectedOptions;

      // Update color display
      var colorValueEl = self.section.querySelector('[data-sticky-atc-color]');
      if (colorValueEl && options) {
        // Find color option — check all positions for a color value
        var mainProductEl = document.querySelector('.oddit-section-main-product');
        if (mainProductEl) {
          var activeColorSwatch = mainProductEl.querySelector('.oddit-section-main-product__swatch--active');
          if (activeColorSwatch) {
            var colorName = activeColorSwatch.getAttribute('data-option-value');
            if (colorName) {
              colorValueEl.textContent = colorName;
              colorValueEl.setAttribute('aria-label', 'Change color: ' + colorName);
            }
            // Update swatch preview (asset PNG + theme CSS var — matches PDP swatches)
            var swatchEl = self.section.querySelector('.oddit-section-sticky-atc__swatch-inner');
            if (swatchEl) {
              var handleized = activeColorSwatch.getAttribute('data-color');
              var assetUrl = activeColorSwatch.getAttribute('data-swatch-asset-url');
              if (handleized) {
                swatchEl.style.backgroundColor = 'var(--swatch-' + handleized + ', #ccc)';
              }
              if (assetUrl) {
                swatchEl.style.backgroundImage = 'url("' + assetUrl.replace(/"/g, '\\"') + '")';
              } else {
                swatchEl.style.backgroundImage = '';
              }
              swatchEl.style.backgroundSize = 'cover';
              swatchEl.style.backgroundPosition = 'center';
            }
          }
        }
      }

      // Update size display. Reset back to the placeholder ("Select a size")
      // when nothing is active — e.g. after switching to a color whose old
      // size doesn't exist — so the badge doesn't keep stale text.
      var sizeValueEl = self.section.querySelector('[data-sticky-atc-size]');
      if (sizeValueEl && options) {
        var mainProductEl2 = document.querySelector('.oddit-section-main-product');
        if (mainProductEl2) {
          var activeSize = mainProductEl2.querySelector('.oddit-section-main-product__size-option--active');
          if (activeSize) {
            var sizeName = activeSize.getAttribute('data-option-value');
            if (sizeName) {
              sizeValueEl.textContent = sizeName;
            }
          } else {
            var placeholder = sizeValueEl.getAttribute('data-placeholder');
            if (placeholder) {
              sizeValueEl.textContent = placeholder;
            }
          }
        }
      }

      // Update button state and variant ID. Mirrors the main ATC button:
      // when no size has been picked yet, show "Select a size" instead of
      // "Sold out".
      var button = self.section.querySelector('[data-sticky-atc-button]');
      if (button) {
        if (variant) {
          button.setAttribute('data-variant-id', variant.id);
        }
        var mainProductElForBtn = document.querySelector('.oddit-section-main-product');
        var hasSizeSelectorMain = mainProductElForBtn && !!mainProductElForBtn.querySelector('.oddit-section-main-product__size-option');
        var sizeSelectedMain = mainProductElForBtn && !!mainProductElForBtn.querySelector('.oddit-section-main-product__size-option--active');
        if (hasSizeSelectorMain && !sizeSelectedMain) {
          button.disabled = true;
          button.textContent = 'SELECT A SIZE';
        } else if (variant && variant.available) {
          button.disabled = false;
          button.textContent = 'ADD TO BAG';
        } else {
          button.disabled = true;
          button.textContent = 'SOLD OUT';
        }
      }
    };

    document.addEventListener('oddit:variant:change', this.variantChangeHandler);

    /* Scroll to main product options when sticky ATC option is clicked
       ====================================================================== */

    var colorBtn = this.section.querySelector('[data-sticky-atc-color]');
    var sizeBtn = this.section.querySelector('[data-sticky-atc-size]');

    if (colorBtn) {
      colorBtn.addEventListener('click', function () {
        var target = document.querySelector('.oddit-section-main-product__swatches');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    if (sizeBtn) {
      sizeBtn.addEventListener('click', function () {
        var target = document.querySelector('.oddit-section-main-product__sizes');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    /* Add to Cart
       ====================================================================== */

    var atcButton = this.section.querySelector('[data-sticky-atc-button]');
    if (atcButton) {
      atcButton.addEventListener('click', function () {
        if (atcButton.disabled) return;

        var variantId = atcButton.getAttribute('data-variant-id');
        if (!variantId) return;

        var originalText = atcButton.textContent;
        atcButton.disabled = true;
        atcButton.textContent = 'ADDING...';

        var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Add to cart failed');
            return response.json();
          })
          .then(function () {
            return fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
              return r.json();
            });
          })
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
            document.dispatchEvent(new CustomEvent('oddit:cart:updated'));
            var refreshPromise = Promise.resolve();
            if (window.odditCartDrawer && typeof window.odditCartDrawer.refresh === 'function') {
              refreshPromise = window.odditCartDrawer.refresh().catch(function () {});
            }
            return refreshPromise;
          })
          .then(function () {
            if (window.odditCartDrawer && typeof window.odditCartDrawer.open === 'function') {
              window.odditCartDrawer.open();
            }
            atcButton.textContent = originalText;
            atcButton.disabled = false;
          })
          .catch(function (err) {
            console.error('Sticky ATC error:', err);
            atcButton.disabled = false;
            atcButton.textContent = originalText;
          });
      });
    }

    /* Hide when footer is reached (mobile)
       ====================================================================== */

    var footerEl = document.querySelector('.oddit-footer-main') || document.querySelector('footer');
    if (footerEl) {
      this.footerObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            self.footerVisible = entry.isIntersecting;
            if (entry.isIntersecting) {
              self.section.classList.remove('is-visible');
            } else if (self.isVisible) {
              self.section.classList.add('is-visible');
            }
          });
        },
        { root: null, threshold: 0 },
      );
      this.footerObserver.observe(footerEl);
    }
  };

  StickyATC.prototype.show = function () {
    if (!this.footerVisible && !this.isVisible) {
      this.isVisible = true;
      this.section.classList.add('is-visible');
    }
  };

  StickyATC.prototype.hide = function () {
    if (this.isVisible) {
      this.isVisible = false;
      this.section.classList.remove('is-visible');
    }
  };

  StickyATC.prototype.destroy = function () {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    if (this.footerObserver) {
      this.footerObserver.disconnect();
      this.footerObserver = null;
    }
    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler);
      this.scrollHandler = null;
    }
    if (this.variantChangeHandler) {
      document.removeEventListener('oddit:variant:change', this.variantChangeHandler);
      this.variantChangeHandler = null;
    }
    this.section.classList.remove('is-visible');
    this.isVisible = false;
  };

  // Initialize
  function initSection(sectionEl) {
    if (sectionEl) {
      sectionEl._stickyATC = new StickyATC(sectionEl);
    }
  }

  var el = document.querySelector('.oddit-section-sticky-atc');
  if (el) {
    initSection(el);
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', function (evt) {
    var sectionEl = evt.target.querySelector('.oddit-section-sticky-atc');
    if (sectionEl) {
      initSection(sectionEl);
    }
  });

  document.addEventListener('shopify:section:unload', function (evt) {
    var sectionEl = evt.target.querySelector('.oddit-section-sticky-atc');
    if (sectionEl && sectionEl._stickyATC) {
      sectionEl._stickyATC.destroy();
      delete sectionEl._stickyATC;
    }
  });
})();
